export default {
  strict: true,
  namespaced: true,
  state: {
    title: '',
    tnc: {
      text: '',
      img: '',
      pickupLabel: ''
    },
    tcp: {
      text: '',
      img: '',
      pickupLabel: ''
    }
  },
  mutations: {
    setInstruction (state, data) {
      state.title = data.title
      state.tnc = data.tnc
      state.tcp = data.tcp
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/instructions.js